import React, { useEffect, useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  ScrollView,
  ActivityIndicator,
  KeyboardAvoidingView,
  TouchableWithoutFeedback,
  TouchableOpacity,
  RefreshControl,
  Alert,
} from "react-native";
import firebase from "firebase";
import DeviceCard from "../../components/DeviceCard";
import { useSelector, useDispatch } from "react-redux";
import * as deviceActions from "../../store/actions/device";
import Colors from "../../constants/Colors";
import NoDeviceScreen from "./NoDeviceScreen";
import DefaultText from "../../components/text/DefaultText";
import { HeaderButtons, Item } from "react-navigation-header-buttons";
import CastButton from "../../components/CastButton";
import { SwipeListView } from "react-native-swipe-list-view";
import alertWrapper from "../../components/web/alert.web";
const DeviceScreen = (props) => {
  const [isLoading, setIsLoading] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const userDevices = useSelector((state) => state.devices.myDevices);
  const socket = useSelector((state) => state.socket.io);
  const dispatch = useDispatch();
  const userId = firebase.auth().currentUser?.uid;

  useEffect(() => {
    if (userId) {
      setIsLoading(true);
      dispatch(deviceActions.fetchDevices()).then(() => {
        setIsLoading(false);
      });
    }
  }, [dispatch]);

  const onRefresh = () => {
    console.log("onRefresh");
    setRefreshing(true);

    dispatch(deviceActions.fetchDevices()).then(() => setRefreshing(false));
  };
  React.useLayoutEffect(() => {
    props.navigation.setOptions({
      headerRight: () =>
        userId == null ? null : (
          <HeaderButtons HeaderButtonComponent={CastButton}>
            <Item
              title="Add"
              iconName={"add"}
              onPress={() => props.navigation.navigate("PairDeviceScreen")}
            />
          </HeaderButtons>
        ),
    });
  }, [props.navigation]);

  const renderDeviceCard = (itemData) => {
    return (
      <View
        onPress={() => console.log("You touched me")}
        style={styles.rowFront}
        underlayColor={"black"}
      >
        <DeviceCard
          key={itemData.item.deviceId}
          deviceId={itemData.item.deviceId}
          name={itemData.item.name}
          power={itemData.item.settings.power}
          play={itemData.item.settings.play}
          volume={itemData.item.settings.volume}
          mute={itemData.item.settings.mute}
          brightnest={itemData.item.settings.brightnest}
          brightAuto={itemData.item.settings.brightAuto}
          speed={itemData.item.settings.speed}
          playlist={itemData.item.playlist}
        />
      </View>
    );
  };
  const renderHiddenItem = (data, rowMap) => (
    <View style={styles.rowBack}>
      <TouchableOpacity
        style={[styles.backRightBtn, styles.backRightBtnRight]}
        onPress={() => deleteRow(rowMap, data.item)}
      >
        <Text style={styles.backTextWhite}>Delete</Text>
      </TouchableOpacity>
    </View>
  );
  const closeRow = (rowMap, rowKey) => {
    if (rowMap[rowKey]) {
      rowMap[rowKey].closeRow();
    }
  };
  const deleteRow = (rowMap, device) => {
    const rowKey = device.deviceId;
    console.log("deleteRow");
    alertWrapper("Are you sure?", "Do you really want to delete this device?", [
      { text: "No", style: "cancel" },
      {
        text: "Yes",
        style: "confirm",
        onPress: () => {
          dispatch(deviceActions.removeDevice(device, socket));
          closeRow(rowMap, rowKey);
        },
      },
    ]);
  };
  const onRowDidOpen = (rowKey) => {
    console.log("This row opened", rowKey);
  };

  if (userId == null) {
    return (
      <View style={styles.centered}>
        <DefaultText style={styles.text}>Please log in first</DefaultText>
      </View>
    );
  }
  if (isLoading) {
    return (
      <View style={styles.centered}>
        <ActivityIndicator size="large" color={Colors.primary} />
      </View>
    );
  }
  if (userDevices.length === 0) {
    return <NoDeviceScreen />;
  }
  return (
    <View style={styles.screen}>
      {refreshing && <ActivityIndicator size="small" color={Colors.primary} />}

      <SwipeListView
        data={userDevices}
        renderItem={renderDeviceCard}
        keyExtractor={(item) => item.deviceId}
        renderHiddenItem={renderHiddenItem}
        rightOpenValue={-75}
        // previewRowKey={"0"}
        // previewOpenValue={-40}
        // previewOpenDelay={3000}
        disableRightSwipe={true}
        onRowDidOpen={onRowDidOpen}
        refreshControl={
          <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
        }
      />
    </View>
  );
};
const styles = StyleSheet.create({
  screen: {
    flex: 1,
  },
  text: {
    fontSize: 18,
  },
  centered: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  rowBack: {
    alignItems: "center",
    backgroundColor: "black",
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
    paddingLeft: 15,
  },
  backRightBtn: {
    alignItems: "center",
    bottom: 0,
    justifyContent: "center",
    position: "absolute",
    top: 0,
    width: 75,
  },
  backRightBtnRight: {
    backgroundColor: "red",
    right: 0,
  },
  rowFront: {
    backgroundColor: "black",
  },
});

export default DeviceScreen;
